import { useLocation } from 'react-router-dom';

export function useRouteQuery() {
  return new URLSearchParams(useLocation().search);
}
